import { connect } from 'react-redux';
import { getDeviceAliasForModal } from "../../../../store/blocks/devices/modalSelectors";
import { CurrentDeviceProvider } from "../../../../store/blocks/devices/selectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    value: getDeviceAliasForModal(state)
  };
};
export var CurrentDeviceContainer = connect(mapStateToProps)(CurrentDeviceProvider);